<script>
  /* Components */
  import NavbarSmall from "./NavbarSmall.svelte";
  import NavbarBig from "./NavbarBig.svelte";

  /* Variable for Navbar toggle */
  let screenWidth;
</script>

<!-- Get current screenwidth for toggle Navbar -->
<svelte:window bind:innerWidth={ screenWidth } />

<!-- Show Navbar according to screenWidth -->
{#if screenWidth > 780}
  <NavbarBig/>
{:else}
  <NavbarSmall/>
{/if}
